import { AxiosResponse } from 'axios';
import { supabase } from '@/lib/supabase';
import { asResponse } from '@/lib/supabase-helpers';

type TotalByOwner = {
  name: string;
  id: string;
  total: number;
};

type TotalByOwnerResponse = {
  totalOfCandidatesByOwner: TotalByOwner[];
};

type AvgTimeInDays = {
  [x: string]: number;
};

type GetCandidateByOnwerType = {
  status: string;
  startDate: string;
  endDate: string;
};

const getNewCandidatesByOwners = async (
  params: GetCandidateByOnwerType
): Promise<AxiosResponse<TotalByOwnerResponse>> => {
  const { data, error } = await supabase.rpc('rpc_candidates_by_owner', {
    p_status: params.status || '',
    p_start: params.startDate,
    p_end: params.endDate,
  });

  if (error) throw error;
  return asResponse<TotalByOwnerResponse>({
    totalOfCandidatesByOwner: data || [],
  });
};

const getAverageToAcceptanceOrRejection = async (): Promise<AxiosResponse<AvgTimeInDays>> => {
  const { data, error } = await supabase.rpc('rpc_avg_time_to_decision');

  if (error) throw error;
  return asResponse<AvgTimeInDays>(data || {});
};

export default {
  getNewCandidatesByOwners,
  getAverageToAcceptanceOrRejection,
};
